import fire from '../conf/initFirebase';
const itemRef = fire.database().ref('skins');

const SkinsActions = Object.freeze({
    get: () => {
        return itemRef;
    }
});

export default SkinsActions;


// WEBPACK FOOTER //
// ./src/actions/skins.actions.js